module.exports = __webpack_public_path__ + "static/media/9DESA24.41c9a4f9.jpg";